// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./styles/fonts/EuclidCircularA-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./styles/fonts/EuclidCircularA-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./styles/fonts/GraphikLCG-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./styles/fonts/GraphikLCG-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #E6EAED; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: "DM Mono"; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #89909A; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #89909A; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
@media (min-width: 2000px) {

  .container {
    max-width: 2000px;
  }
}
.\\!pointer-events-none {
  pointer-events: none !important;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.\\!invisible {
  visibility: hidden !important;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.-inset-2 {
  top: -0.5rem;
  right: -0.5rem;
  bottom: -0.5rem;
  left: -0.5rem;
}
.-inset-\\[1px\\] {
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
}
.inset-0 {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.inset-0\\.5 {
  top: 0.125rem;
  right: 0.125rem;
  bottom: 0.125rem;
  left: 0.125rem;
}
.\\!inset-y-5 {
  top: 1.25rem !important;
  bottom: 1.25rem !important;
}
.inset-y-2 {
  top: 0.5rem;
  bottom: 0.5rem;
}
.\\!left-full {
  left: 100% !important;
}
.\\!right-full {
  right: 100% !important;
}
.\\!top-0 {
  top: 0px !important;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-1\\.5 {
  bottom: -0.375rem;
}
.-bottom-\\[0px\\] {
  bottom: -0px;
}
.-bottom-\\[2px\\] {
  bottom: -2px;
}
.-bottom-\\[5px\\] {
  bottom: -5px;
}
.-left-0 {
  left: -0px;
}
.-left-1 {
  left: -0.25rem;
}
.-left-2 {
  left: -0.5rem;
}
.-right-0 {
  right: -0px;
}
.-right-1 {
  right: -0.25rem;
}
.-right-2 {
  right: -0.5rem;
}
.-right-\\[1000px\\] {
  right: -1000px;
}
.-top-1 {
  top: -0.25rem;
}
.-top-1\\.5 {
  top: -0.375rem;
}
.-top-10 {
  top: -2.5rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-4 {
  top: -1rem;
}
.-top-\\[3px\\] {
  top: -3px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-10 {
  bottom: 2.5rem;
}
.bottom-12 {
  bottom: 3rem;
}
.bottom-16 {
  bottom: 4rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-7 {
  bottom: 1.75rem;
}
.bottom-\\[1px\\] {
  bottom: 1px;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\.5 {
  left: 0.625rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-5 {
  left: 1.25rem;
}
.left-\\[-6px\\] {
  left: -6px;
}
.left-\\[-8px\\] {
  left: -8px;
}
.left-\\[0\\.9rem\\] {
  left: 0.9rem;
}
.left-\\[11px\\] {
  left: 11px;
}
.left-\\[120px\\] {
  left: 120px;
}
.left-\\[14\\%\\] {
  left: 14%;
}
.left-\\[19px\\] {
  left: 19px;
}
.left-\\[33\\%\\] {
  left: 33%;
}
.left-\\[33px\\] {
  left: 33px;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.left-\\[6px\\] {
  left: 6px;
}
.left-\\[calc\\(100\\%\\+4px\\)\\] {
  left: calc(100% + 4px);
}
.left-\\[calc\\(100\\%\\+6px\\)\\] {
  left: calc(100% + 6px);
}
.left-\\[calc\\(50\\%\\)\\] {
  left: calc(50%);
}
.right-0 {
  right: 0px;
}
.right-0\\.5 {
  right: 0.125rem;
}
.right-1 {
  right: 0.25rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-\\[-6px\\] {
  right: -6px;
}
.right-\\[240px\\] {
  right: 240px;
}
.right-\\[6px\\] {
  right: 6px;
}
.right-\\[8px\\] {
  right: 8px;
}
.top-0 {
  top: 0px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-16 {
  top: 4rem;
}
.top-2 {
  top: 0.5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-8 {
  top: 2rem;
}
.top-\\[120px\\] {
  top: 120px;
}
.top-\\[14\\%\\] {
  top: 14%;
}
.top-\\[16px\\] {
  top: 16px;
}
.top-\\[1px\\] {
  top: 1px;
}
.top-\\[24px\\] {
  top: 24px;
}
.top-\\[2px\\] {
  top: 2px;
}
.top-\\[33\\%\\] {
  top: 33%;
}
.top-\\[35px\\] {
  top: 35px;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-\\[8px\\] {
  top: 8px;
}
.top-\\[calc\\(100\\%\\+2px\\)\\] {
  top: calc(100% + 2px);
}
.top-\\[calc\\(100\\%\\+4px\\)\\] {
  top: calc(100% + 4px);
}
.top-\\[calc\\(100\\%-140px\\)\\] {
  top: calc(100% - 140px);
}
.top-\\[calc\\(100\\%-2rem\\)\\] {
  top: calc(100% - 2rem);
}
.top-\\[calc\\(50\\%-0\\.2rem\\)\\] {
  top: calc(50% - 0.2rem);
}
.top-\\[calc\\(50\\%-2px\\)\\] {
  top: calc(50% - 2px);
}
.top-\\[calc\\(50\\%-8px\\)\\] {
  top: calc(50% - 8px);
}
.top-full {
  top: 100%;
}
.isolate {
  isolation: isolate;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[-1\\] {
  z-index: -1;
}
.z-\\[10001\\] {
  z-index: 10001;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[10\\] {
  z-index: 10;
}
.z-\\[1110\\] {
  z-index: 1110;
}
.z-\\[1111\\] {
  z-index: 1111;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[200\\] {
  z-index: 200;
}
.z-\\[20\\] {
  z-index: 20;
}
.z-\\[250\\] {
  z-index: 250;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[50\\] {
  z-index: 50;
}
.z-\\[5\\] {
  z-index: 5;
}
.z-\\[90\\] {
  z-index: 90;
}
.z-\\[999\\] {
  z-index: 999;
}
.float-left {
  float: left;
}
.\\!m-0 {
  margin: 0px !important;
}
.m-0 {
  margin: 0px;
}
.m-3 {
  margin: 0.75rem;
}
.-mx-0\\.5 {
  margin-left: -0.125rem;
  margin-right: -0.125rem;
}
.-mx-2\\.5 {
  margin-left: -0.625rem;
  margin-right: -0.625rem;
}
.-mx-3 {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-\\[10px\\] {
  margin-top: 10px;
  margin-bottom: 10px;
}
.my-\\[2px\\] {
  margin-top: 2px;
  margin-bottom: 2px;
}
.\\!ml-1 {
  margin-left: 0.25rem !important;
}
.-mb-1 {
  margin-bottom: -0.25rem;
}
.-mb-3 {
  margin-bottom: -0.75rem;
}
.-ml-0 {
  margin-left: -0px;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-ml-2 {
  margin-left: -0.5rem;
}
.-ml-\\[2px\\] {
  margin-left: -2px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[2px\\] {
  margin-bottom: 2px;
}
.mb-\\[72px\\] {
  margin-bottom: 72px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-\\[8px\\] {
  margin-left: 8px;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[16px\\] {
  margin-top: 16px;
}
.mt-\\[24px\\] {
  margin-top: 24px;
}
.mt-\\[2px\\] {
  margin-top: 2px;
}
.mt-\\[40px\\] {
  margin-top: 40px;
}
.box-border {
  box-sizing: border-box;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.aspect-\\[16\\/9\\] {
  aspect-ratio: 16/9;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.\\!h-4 {
  height: 1rem !important;
}
.\\!h-8 {
  height: 2rem !important;
}
.\\!h-\\[32px\\] {
  height: 32px !important;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\/2 {
  height: 50%;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-20 {
  height: 5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-52 {
  height: 13rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[--height\\] {
  height: var(--height);
}
.h-\\[--size\\] {
  height: var(--size);
}
.h-\\[--toolbar-height\\] {
  height: var(--toolbar-height);
}
.h-\\[100dvh\\] {
  height: 100dvh;
}
.h-\\[100svh\\] {
  height: 100svh;
}
.h-\\[10px\\] {
  height: 10px;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[12px\\] {
  height: 12px;
}
.h-\\[14px\\] {
  height: 14px;
}
.h-\\[160px\\] {
  height: 160px;
}
.h-\\[16px\\] {
  height: 16px;
}
.h-\\[180px\\] {
  height: 180px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[250px\\] {
  height: 250px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[320px\\] {
  height: 320px;
}
.h-\\[332px\\] {
  height: 332px;
}
.h-\\[350px\\] {
  height: 350px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[600px\\] {
  height: 600px;
}
.h-\\[720px\\] {
  height: 720px;
}
.h-\\[80\\%\\] {
  height: 80%;
}
.h-\\[90\\%\\] {
  height: 90%;
}
.h-\\[90px\\] {
  height: 90px;
}
.h-\\[96px\\] {
  height: 96px;
}
.h-\\[calc\\(100\\%-3px\\)\\] {
  height: calc(100% - 3px);
}
.h-\\[calc\\(100\\%-48px\\)\\] {
  height: calc(100% - 48px);
}
.h-\\[calc\\(100\\%-6px\\)\\] {
  height: calc(100% - 6px);
}
.h-auto {
  height: auto;
}
.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-inherit {
  height: inherit;
}
.h-max {
  height: -moz-max-content;
  height: max-content;
}
.h-min {
  height: -moz-min-content;
  height: min-content;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-32 {
  max-height: 8rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[150px\\] {
  max-height: 150px;
}
.max-h-\\[168px\\] {
  max-height: 168px;
}
.max-h-\\[42px\\] {
  max-height: 42px;
}
.max-h-\\[64px\\] {
  max-height: 64px;
}
.max-h-\\[95vh\\] {
  max-height: 95vh;
}
.max-h-full {
  max-height: 100%;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-4 {
  min-height: 1rem;
}
.min-h-8 {
  min-height: 2rem;
}
.min-h-\\[168px\\] {
  min-height: 168px;
}
.min-h-\\[170px\\] {
  min-height: 170px;
}
.min-h-\\[1px\\] {
  min-height: 1px;
}
.min-h-\\[2\\.5rem\\] {
  min-height: 2.5rem;
}
.min-h-\\[20px\\] {
  min-height: 20px;
}
.min-h-\\[500px\\] {
  min-height: 500px;
}
.min-h-\\[600px\\] {
  min-height: 600px;
}
.min-h-\\[64px\\] {
  min-height: 64px;
}
.min-h-\\[75px\\] {
  min-height: 75px;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-4 {
  width: 1rem !important;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[--blockWidth\\] {
  width: var(--blockWidth);
}
.w-\\[--size\\] {
  width: var(--size);
}
.w-\\[--width\\] {
  width: var(--width);
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[11px\\] {
  width: 11px;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[126px\\] {
  width: 126px;
}
.w-\\[12px\\] {
  width: 12px;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[14px\\] {
  width: 14px;
}
.w-\\[160px\\] {
  width: 160px;
}
.w-\\[16px\\] {
  width: 16px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[210px\\] {
  width: 210px;
}
.w-\\[220px\\] {
  width: 220px;
}
.w-\\[240px\\] {
  width: 240px;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[258px\\] {
  width: 258px;
}
.w-\\[280px\\] {
  width: 280px;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[320px\\] {
  width: 320px;
}
.w-\\[327px\\] {
  width: 327px;
}
.w-\\[340px\\] {
  width: 340px;
}
.w-\\[360px\\] {
  width: 360px;
}
.w-\\[36px\\] {
  width: 36px;
}
.w-\\[3rem\\] {
  width: 3rem;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[42px\\] {
  width: 42px;
}
.w-\\[450px\\] {
  width: 450px;
}
.w-\\[48px\\] {
  width: 48px;
}
.w-\\[560px\\] {
  width: 560px;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-\\[70px\\] {
  width: 70px;
}
.w-\\[720px\\] {
  width: 720px;
}
.w-\\[800px\\] {
  width: 800px;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[90px\\] {
  width: 90px;
}
.w-\\[96px\\] {
  width: 96px;
}
.w-\\[calc\\(100\\%-3px\\)\\] {
  width: calc(100% - 3px);
}
.w-\\[calc\\(100\\%-6px\\)\\] {
  width: calc(100% - 6px);
}
.w-\\[calc\\(25\\%-6px\\)\\] {
  width: calc(25% - 6px);
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-inherit {
  width: inherit;
}
.w-max {
  width: -moz-max-content;
  width: max-content;
}
.w-screen {
  width: 100vw;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-4 {
  min-width: 1rem;
}
.min-w-\\[148px\\] {
  min-width: 148px;
}
.min-w-\\[2\\.5rem\\] {
  min-width: 2.5rem;
}
.min-w-\\[21px\\] {
  min-width: 21px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[250px\\] {
  min-width: 250px;
}
.min-w-\\[350px\\] {
  min-width: 350px;
}
.min-w-\\[375px\\] {
  min-width: 375px;
}
.min-w-\\[400px\\] {
  min-width: 400px;
}
.min-w-\\[54px\\] {
  min-width: 54px;
}
.min-w-\\[64px\\] {
  min-width: 64px;
}
.min-w-\\[6rem\\] {
  min-width: 6rem;
}
.min-w-\\[80px\\] {
  min-width: 80px;
}
.min-w-\\[850px\\] {
  min-width: 850px;
}
.min-w-\\[900px\\] {
  min-width: 900px;
}
.min-w-\\[90px\\] {
  min-width: 90px;
}
.min-w-full {
  min-width: 100%;
}
.min-w-min {
  min-width: -moz-min-content;
  min-width: min-content;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-\\[15rem\\] {
  max-width: 15rem;
}
.max-w-\\[210px\\] {
  max-width: 210px;
}
.max-w-\\[240px\\] {
  max-width: 240px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[520px\\] {
  max-width: 520px;
}
.max-w-\\[550px\\] {
  max-width: 550px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[64px\\] {
  max-width: 64px;
}
.max-w-\\[700px\\] {
  max-width: 700px;
}
.max-w-fit {
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-min {
  max-width: -moz-min-content;
  max-width: min-content;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-\\[1\\] {
  flex: 1;
}
.flex-\\[2\\] {
  flex: 2;
}
.flex-shrink {
  flex-shrink: 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-\\[1\\] {
  flex-shrink: 1;
}
.flex-grow {
  flex-grow: 1;
}
.flex-grow-0 {
  flex-grow: 0;
}
.grow {
  flex-grow: 1;
}
.origin-\\[45\\%_45\\%\\] {
  transform-origin: 45% 45%;
}
.origin-\\[55\\%_55\\%\\] {
  transform-origin: 55% 55%;
}
.origin-bottom {
  transform-origin: bottom;
}
.origin-bottom-left {
  transform-origin: bottom left;
}
.origin-center {
  transform-origin: center;
}
.origin-left {
  transform-origin: left;
}
.origin-right {
  transform-origin: right;
}
.origin-top {
  transform-origin: top;
}
.origin-top-left {
  transform-origin: top left;
}
.\\!translate-x-\\[calc\\(100\\%\\+2px\\)\\] {
  --tw-translate-x: calc(100% + 2px) !important;
  transform: translate(calc(100% + 2px), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-x-1 {
  --tw-translate-x: -0.25rem;
  transform: translate(-0.25rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-10 {
  --tw-translate-x: -2.5rem;
  transform: translate(-2.5rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-20 {
  --tw-translate-x: -5rem;
  transform: translate(-5rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-8 {
  --tw-translate-x: -2rem;
  transform: translate(-2rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[13px\\] {
  --tw-translate-x: -13px;
  transform: translate(-13px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[1px\\] {
  --tw-translate-x: -1px;
  transform: translate(-1px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[2px\\] {
  --tw-translate-x: -2px;
  transform: translate(-2px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[5px\\] {
  --tw-translate-x: -5px;
  transform: translate(-5px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[6px\\] {
  --tw-translate-x: -6px;
  transform: translate(-6px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[8px\\] {
  --tw-translate-x: -8px;
  transform: translate(-8px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(-100%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), -0.25rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-12 {
  --tw-translate-y: -3rem;
  transform: translate(var(--tw-translate-x), -3rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2 {
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), -0.5rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-5 {
  --tw-translate-y: -1.25rem;
  transform: translate(var(--tw-translate-x), -1.25rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-6 {
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), -1.5rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[1px\\] {
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), -1px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[200px\\] {
  --tw-translate-y: -200px;
  transform: translate(var(--tw-translate-x), -200px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[60\\%\\] {
  --tw-translate-y: -60%;
  transform: translate(var(--tw-translate-x), -60%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[65\\%\\] {
  --tw-translate-y: -65%;
  transform: translate(var(--tw-translate-x), -65%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[70\\%\\] {
  --tw-translate-y: -70%;
  transform: translate(var(--tw-translate-x), -70%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[75\\%\\] {
  --tw-translate-y: -75%;
  transform: translate(var(--tw-translate-x), -75%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[8px\\] {
  --tw-translate-y: -8px;
  transform: translate(var(--tw-translate-x), -8px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(0px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(0.25rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-10 {
  --tw-translate-x: 2.5rem;
  transform: translate(2.5rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2 {
  --tw-translate-x: 0.5rem;
  transform: translate(0.5rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-20 {
  --tw-translate-x: 5rem;
  transform: translate(5rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[--offset-x-to-group\\] {
  --tw-translate-x: var(--offset-x-to-group);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-5px\\] {
  --tw-translate-x: -5px;
  transform: translate(-5px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[13px\\] {
  --tw-translate-x: 13px;
  transform: translate(13px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[1px\\] {
  --tw-translate-x: 1px;
  transform: translate(1px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[2px\\] {
  --tw-translate-x: 2px;
  transform: translate(2px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[5px\\] {
  --tw-translate-x: 5px;
  transform: translate(5px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[7px\\] {
  --tw-translate-x: 7px;
  transform: translate(7px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[calc\\(100\\%-18px\\)\\] {
  --tw-translate-x: calc(100% - 18px);
  transform: translate(calc(100% - 18px), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(100%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), 0px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0\\.5 {
  --tw-translate-y: 0.125rem;
  transform: translate(var(--tw-translate-x), 0.125rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), 50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-12 {
  --tw-translate-y: 3rem;
  transform: translate(var(--tw-translate-x), 3rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2 {
  --tw-translate-y: 0.5rem;
  transform: translate(var(--tw-translate-x), 0.5rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-6 {
  --tw-translate-y: 1.5rem;
  transform: translate(var(--tw-translate-x), 1.5rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[--offset-y-to-group\\] {
  --tw-translate-y: var(--offset-y-to-group);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-6px\\] {
  --tw-translate-y: -6px;
  transform: translate(var(--tw-translate-x), -6px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[100px\\] {
  --tw-translate-y: 100px;
  transform: translate(var(--tw-translate-x), 100px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[12px\\] {
  --tw-translate-y: 12px;
  transform: translate(var(--tw-translate-x), 12px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[3px\\] {
  --tw-translate-y: 3px;
  transform: translate(var(--tw-translate-x), 3px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[7px\\] {
  --tw-translate-y: 7px;
  transform: translate(var(--tw-translate-x), 7px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-full {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), 100%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\!-rotate-\\[180deg\\] {
  --tw-rotate: -180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(-180deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.\\!rotate-0 {
  --tw-rotate: 0deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(0deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.\\!rotate-\\[180deg\\] {
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(180deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-rotate-45 {
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(-45deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(-90deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-\\[135deg\\] {
  --tw-rotate: -135deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(-135deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(180deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(45deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(90deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[135deg\\] {
  --tw-rotate: 135deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(135deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[var\\(--rotation\\)\\] {
  --tw-rotate: var(--rotation);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\!scale-100 {
  --tw-scale-x: 1 !important;
  --tw-scale-y: 1 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0) scaleY(0);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-50 {
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(.5) scaleY(.5);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(.75) scaleY(.75);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(.95) scaleY(.95);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[--scale\\] {
  --tw-scale-x: var(--scale);
  --tw-scale-y: var(--scale);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.5\\] {
  --tw-scale-x: 0.5;
  --tw-scale-y: 0.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.5) scaleY(0.5);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.66\\] {
  --tw-scale-x: 0.66;
  --tw-scale-y: 0.66;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.66) scaleY(0.66);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.75\\] {
  --tw-scale-x: 0.75;
  --tw-scale-y: 0.75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.75) scaleY(0.75);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.8\\] {
  --tw-scale-x: 0.8;
  --tw-scale-y: 0.8;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.8) scaleY(0.8);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.9\\] {
  --tw-scale-x: 0.9;
  --tw-scale-y: 0.9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.9) scaleY(0.9);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.25\\] {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.25) scaleY(1.25);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.3\\] {
  --tw-scale-x: 1.3;
  --tw-scale-y: 1.3;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.3) scaleY(1.3);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.5\\] {
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.5) scaleY(1.5);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-scale-x-100 {
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(-1) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-scale-y-100 {
  --tw-scale-y: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(-1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\!transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-gpu {
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-fast-bounce-1 {
  animation: bounce 0.5s ease-out infinite 0s;
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-fast-bounce-2 {
  animation: bounce 0.5s ease-out infinite 0.1s;
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-fast-bounce-3 {
  animation: bounce 0.5s ease-out infinite 0.2s;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-ns-resize {
  cursor: ns-resize;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-text {
  cursor: text;
}
.select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.select-text {
  -webkit-user-select: text;
     -moz-user-select: text;
          user-select: text;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.snap-x {
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.snap-center {
  scroll-snap-align: center;
}
.scroll-m-3 {
  scroll-margin: 0.75rem;
}
.list-inside {
  list-style-position: inside;
}
.list-disc {
  list-style-type: disc;
}
.grid-flow-row {
  grid-auto-flow: row;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-\\[--repeat\\] {
  grid-template-columns: var(--repeat);
}
.grid-cols-\\[2fr_1fr_1fr\\] {
  grid-template-columns: 2fr 1fr 1fr;
}
.grid-cols-\\[40px_minmax\\(280px\\2c 2fr\\)_minmax\\(140px\\2c 1fr\\)_minmax\\(140px\\2c 1fr\\)_minmax\\(140px\\2c 1fr\\)_minmax\\(120px\\2c 1fr\\)_32px\\] {
  grid-template-columns: 40px minmax(280px,2fr) minmax(140px,1fr) minmax(140px,1fr) minmax(140px,1fr) minmax(120px,1fr) 32px;
}
.grid-rows-\\[1fr_1fr\\] {
  grid-template-rows: 1fr 1fr;
}
.grid-rows-none {
  grid-template-rows: none;
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.content-center {
  align-content: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-stretch {
  justify-content: stretch;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-9 {
  gap: 2.25rem;
}
.gap-\\[0\\.3em\\] {
  gap: 0.3em;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[1px\\] {
  gap: 1px;
}
.gap-\\[20px\\] {
  gap: 20px;
}
.gap-\\[22px\\] {
  gap: 22px;
}
.gap-\\[26px\\] {
  gap: 26px;
}
.gap-\\[2px\\] {
  gap: 2px;
}
.gap-\\[8px\\] {
  gap: 8px;
}
.gap-x-3 {
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.gap-x-6 {
  -moz-column-gap: 1.5rem;
       column-gap: 1.5rem;
}
.gap-y-12 {
  row-gap: 3rem;
}
.gap-y-6 {
  row-gap: 1.5rem;
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * (1 - 0));
  border-top-width: calc(1px * (1 - var(--tw-divide-y-reverse)));
  border-top-width: calc(1px * calc(1 - 0));
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * 0);
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgba(230, 234, 237, 1);
  border-color: rgba(230, 234, 237, var(--tw-divide-opacity, 1));
}
.self-start {
  align-self: flex-start;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-clip {
  overflow: clip;
}
.overflow-visible {
  overflow: visible;
}
.overflow-scroll {
  overflow: scroll;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-clip {
  overflow-x: clip;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.whitespace-break-spaces {
  white-space: break-spaces;
}
.text-balance {
  text-wrap: balance;
}
.break-words {
  word-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.break-keep {
  word-break: keep-all;
}
.\\!rounded-lg {
  border-radius: 0.5rem !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[1px\\] {
  border-radius: 1px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[24px\\] {
  border-radius: 24px;
}
.rounded-\\[2px\\] {
  border-radius: 2px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-b-md {
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-b-none {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-t-\\[7px\\] {
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-bl-2xl {
  border-bottom-left-radius: 1rem;
}
.rounded-bl-none {
  border-bottom-left-radius: 0px;
}
.rounded-br-2xl {
  border-bottom-right-radius: 1rem;
}
.rounded-tl-2xl {
  border-top-left-radius: 1rem;
}
.rounded-tl-xl {
  border-top-left-radius: 0.75rem;
}
.rounded-tr-2xl {
  border-top-right-radius: 1rem;
}
.\\!border-0 {
  border-width: 0px !important;
}
.\\!border-\\[1px\\] {
  border-width: 1px !important;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[0\\.5px\\] {
  border-width: 0.5px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-\\[20px\\] {
  border-width: 20px;
}
.border-x-\\[1px\\] {
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-y-\\[1px\\] {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-\\[1px\\] {
  border-bottom-width: 1px;
}
.border-l-\\[1px\\] {
  border-left-width: 1px;
}
.border-r-\\[1px\\] {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-t-\\[1px\\] {
  border-top-width: 1px;
}
.\\!border-solid {
  border-style: solid !important;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.\\!border-\\[\\#374FD580\\] {
  border-color: rgba(55,79,213,0.50196) !important;
}
.\\!border-\\[\\#F24822\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgba(242, 72, 34, 1) !important;
  border-color: rgba(242, 72, 34, var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[var\\(--aninix-color-foreground-black-1\\)\\] {
  border-color: var(--aninix-color-foreground-black-1) !important;
}
.\\!border-accent {
  --tw-border-opacity: 1 !important;
  border-color: rgba(55, 79, 213, 1) !important;
  border-color: rgba(55, 79, 213, var(--tw-border-opacity, 1)) !important;
}
.\\!border-black {
  --tw-border-opacity: 1 !important;
  border-color: rgba(0, 0, 0, 1) !important;
  border-color: rgba(0, 0, 0, var(--tw-border-opacity, 1)) !important;
}
.\\!border-gray-700 {
  --tw-border-opacity: 1 !important;
  border-color: rgba(55, 65, 81, 1) !important;
  border-color: rgba(55, 65, 81, var(--tw-border-opacity, 1)) !important;
}
.\\!border-gray-800 {
  --tw-border-opacity: 1 !important;
  border-color: rgba(31, 41, 55, 1) !important;
  border-color: rgba(31, 41, 55, var(--tw-border-opacity, 1)) !important;
}
.\\!border-red {
  --tw-border-opacity: 1 !important;
  border-color: rgba(242, 72, 34, 1) !important;
  border-color: rgba(242, 72, 34, var(--tw-border-opacity, 1)) !important;
}
.\\!border-transparent {
  border-color: transparent !important;
}
.border-\\[\\#5A87BF26\\] {
  border-color: rgba(90,135,191,0.14902);
}
.border-\\[\\#5C65741A\\] {
  border-color: rgba(92,101,116,0.10196);
}
.border-\\[\\#5C6574\\] {
  --tw-border-opacity: 1;
  border-color: rgba(92, 101, 116, 1);
  border-color: rgba(92, 101, 116, var(--tw-border-opacity, 1));
}
.border-\\[\\#CED3D9\\] {
  --tw-border-opacity: 1;
  border-color: rgba(206, 211, 217, 1);
  border-color: rgba(206, 211, 217, var(--tw-border-opacity, 1));
}
.border-\\[\\#D9D9D9\\] {
  --tw-border-opacity: 1;
  border-color: rgba(217, 217, 217, 1);
  border-color: rgba(217, 217, 217, var(--tw-border-opacity, 1));
}
.border-\\[\\#E5E5E5\\] {
  --tw-border-opacity: 1;
  border-color: rgba(229, 229, 229, 1);
  border-color: rgba(229, 229, 229, var(--tw-border-opacity, 1));
}
.border-\\[\\#E6EAED\\] {
  --tw-border-opacity: 1;
  border-color: rgba(230, 234, 237, 1);
  border-color: rgba(230, 234, 237, var(--tw-border-opacity, 1));
}
.border-\\[var\\(--highlight-color\\)\\] {
  border-color: var(--highlight-color);
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, 1);
  border-color: rgba(0, 0, 0, var(--tw-border-opacity, 1));
}
.border-black\\/10 {
  border-color: rgba(0, 0, 0, 0.1);
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgba(245, 246, 248, 1);
  border-color: rgba(245, 246, 248, var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgba(230, 234, 237, 1);
  border-color: rgba(230, 234, 237, var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgba(206, 211, 217, 1);
  border-color: rgba(206, 211, 217, var(--tw-border-opacity, 1));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgba(137, 144, 154, 1);
  border-color: rgba(137, 144, 154, var(--tw-border-opacity, 1));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgba(92, 101, 116, 1);
  border-color: rgba(92, 101, 116, var(--tw-border-opacity, 1));
}
.border-gray-500\\/10 {
  border-color: rgba(92, 101, 116, 0.1);
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgba(55, 65, 81, 1);
  border-color: rgba(55, 65, 81, var(--tw-border-opacity, 1));
}
.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgba(31, 41, 55, 1);
  border-color: rgba(31, 41, 55, var(--tw-border-opacity, 1));
}
.border-red {
  --tw-border-opacity: 1;
  border-color: rgba(242, 72, 34, 1);
  border-color: rgba(242, 72, 34, var(--tw-border-opacity, 1));
}
.border-secondary {
  --tw-border-opacity: 1;
  border-color: rgba(11, 17, 24, 1);
  border-color: rgba(11, 17, 24, var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity, 1));
}
.border-b-\\[\\#DFE8F3\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgba(223, 232, 243, 1);
  border-bottom-color: rgba(223, 232, 243, var(--tw-border-opacity, 1));
}
.border-b-\\[var\\(--aninix-color-foreground-black-05\\)\\] {
  border-bottom-color: var(--aninix-color-foreground-black-05);
}
.border-r-gray-200 {
  --tw-border-opacity: 1;
  border-right-color: rgba(230, 234, 237, 1);
  border-right-color: rgba(230, 234, 237, var(--tw-border-opacity, 1));
}
.border-t-\\[\\#E6EAED\\] {
  --tw-border-opacity: 1;
  border-top-color: rgba(230, 234, 237, 1);
  border-top-color: rgba(230, 234, 237, var(--tw-border-opacity, 1));
}
.border-t-accent\\/30 {
  border-top-color: rgba(55, 79, 213, 0.3);
}
.border-t-gray-200 {
  --tw-border-opacity: 1;
  border-top-color: rgba(230, 234, 237, 1);
  border-top-color: rgba(230, 234, 237, var(--tw-border-opacity, 1));
}
.border-opacity-0 {
  --tw-border-opacity: 0;
}
.border-opacity-10 {
  --tw-border-opacity: 0.1;
}
.border-opacity-100 {
  --tw-border-opacity: 1;
}
.border-opacity-20 {
  --tw-border-opacity: 0.2;
}
.\\!bg-\\[\\#1BC47D\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(27, 196, 125, 1) !important;
  background-color: rgba(27, 196, 125, var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#374FD50D\\] {
  background-color: rgba(55,79,213,0.05098) !important;
}
.\\!bg-\\[\\#374FD5\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(55, 79, 213, 1) !important;
  background-color: rgba(55, 79, 213, var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#F24822\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(242, 72, 34, 1) !important;
  background-color: rgba(242, 72, 34, var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-accent {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(55, 79, 213, 1) !important;
  background-color: rgba(55, 79, 213, var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-accent\\/50 {
  background-color: rgba(55, 79, 213, 0.5) !important;
}
.\\!bg-black {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(0, 0, 0, 1) !important;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-red {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(242, 72, 34, 1) !important;
  background-color: rgba(242, 72, 34, var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-secondary {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(11, 17, 24, 1) !important;
  background-color: rgba(11, 17, 24, var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-\\[\\#0B11184D\\] {
  background-color: rgba(11,17,24,0.30196);
}
.bg-\\[\\#0B1118D9\\] {
  background-color: rgba(11,17,24,0.85098);
}
.bg-\\[\\#0B1118\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(11, 17, 24, 1);
  background-color: rgba(11, 17, 24, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#185ef388\\] {
  background-color: rgba(24,94,243,0.53333);
}
.bg-\\[\\#18A0FB\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(24, 160, 251, 1);
  background-color: rgba(24, 160, 251, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1BC47D40\\] {
  background-color: rgba(27,196,125,0.25098);
}
.bg-\\[\\#1BC47D\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(27, 196, 125, 1);
  background-color: rgba(27, 196, 125, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1BC47D\\]\\/10 {
  background-color: rgba(27, 196, 125, 0.1);
}
.bg-\\[\\#1DB95C88\\] {
  background-color: rgba(29,185,92,0.53333);
}
.bg-\\[\\#30353B\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(48, 53, 59, 1);
  background-color: rgba(48, 53, 59, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#374FD5\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 79, 213, 1);
  background-color: rgba(55, 79, 213, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#5C65741A\\] {
  background-color: rgba(92,101,116,0.10196);
}
.bg-\\[\\#7B61FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(123, 97, 255, 1);
  background-color: rgba(123, 97, 255, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D5F5CC\\]\\/50 {
  background-color: rgba(213, 245, 204, 0.5);
}
.bg-\\[\\#D7E6FA\\]\\/50 {
  background-color: rgba(215, 230, 250, 0.5);
}
.bg-\\[\\#D9D9D9\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(217, 217, 217, 1);
  background-color: rgba(217, 217, 217, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E5E5E5\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 229, 229, 1);
  background-color: rgba(229, 229, 229, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EDF5FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(237, 245, 250, 1);
  background-color: rgba(237, 245, 250, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F0F0F0\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(240, 240, 240, 1);
  background-color: rgba(240, 240, 240, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F2F2F2\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 242, 242, 1);
  background-color: rgba(242, 242, 242, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F5F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 245, 245, 1);
  background-color: rgba(245, 245, 245, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F6F8\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 246, 248, 1);
  background-color: rgba(245, 246, 248, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F7F9FC\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(247, 249, 252, 1);
  background-color: rgba(247, 249, 252, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FDF3D0\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(253, 243, 208, 1);
  background-color: rgba(253, 243, 208, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FEF7E1\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 247, 225, 1);
  background-color: rgba(254, 247, 225, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF6B00\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 107, 0, 1);
  background-color: rgba(255, 107, 0, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF9E00\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 158, 0, 1);
  background-color: rgba(255, 158, 0, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFAA2B88\\] {
  background-color: rgba(255,170,43,0.53333);
}
.bg-\\[\\#FFB0E5\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 176, 229, 1);
  background-color: rgba(255, 176, 229, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFC700\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 199, 0, 1);
  background-color: rgba(255, 199, 0, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF3C8D9\\] {
  background-color: rgba(255,243,200,0.85098);
}
.bg-\\[\\#FFFFFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0f0f0\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(240, 240, 240, 1);
  background-color: rgba(240, 240, 240, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f5f5f5\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 245, 245, 1);
  background-color: rgba(245, 245, 245, var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f67ece\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(246, 126, 206, 1);
  background-color: rgba(246, 126, 206, var(--tw-bg-opacity, 1));
}
.bg-\\[--figma-color-bg-onselected-hover\\] {
  background-color: var(--figma-color-bg-onselected-hover);
}
.bg-\\[--figma-color-bg-onselected\\] {
  background-color: var(--figma-color-bg-onselected);
}
.bg-\\[--figma-color-bg\\] {
  background-color: var(--figma-color-bg);
}
.bg-\\[--figma-color-border\\] {
  background-color: var(--figma-color-border);
}
.bg-\\[--nodeColor\\] {
  background-color: var(--nodeColor);
}
.bg-\\[--toolbar-bg\\] {
  background-color: var(--toolbar-bg);
}
.bg-\\[darkgrey\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(169, 169, 169, 1);
  background-color: rgba(169, 169, 169, var(--tw-bg-opacity, 1));
}
.bg-\\[var\\(--background-white-2\\)\\] {
  background-color: var(--background-white-2);
}
.bg-\\[var\\(--currentColor\\)\\] {
  background-color: var(--currentColor);
}
.bg-\\[var\\(--figma-color-bg\\)\\] {
  background-color: var(--figma-color-bg);
}
.bg-\\[var\\(--figma-color-text\\)\\] {
  background-color: var(--figma-color-text);
}
.bg-\\[var\\(--figma-color-text-01\\)\\] {
  background-color: var(--figma-color-text-01);
}
.bg-\\[var\\(--highlight-color\\)\\] {
  background-color: var(--highlight-color);
}
.bg-accent {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 79, 213, 1);
  background-color: rgba(55, 79, 213, var(--tw-bg-opacity, 1));
}
.bg-accent\\/10 {
  background-color: rgba(55, 79, 213, 0.1);
}
.bg-accent\\/15 {
  background-color: rgba(55, 79, 213, 0.15);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, 1);
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity, 1));
}
.bg-black\\/40 {
  background-color: rgba(0, 0, 0, 0.4);
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(59, 130, 246, 1);
  background-color: rgba(59, 130, 246, var(--tw-bg-opacity, 1));
}
.bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgba(29, 78, 216, 1);
  background-color: rgba(29, 78, 216, var(--tw-bg-opacity, 1));
}
.bg-error {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 72, 34, 1);
  background-color: rgba(242, 72, 34, var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 246, 248, 1);
  background-color: rgba(245, 246, 248, var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(230, 234, 237, 1);
  background-color: rgba(230, 234, 237, var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgba(206, 211, 217, 1);
  background-color: rgba(206, 211, 217, var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(137, 144, 154, 1);
  background-color: rgba(137, 144, 154, var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(249, 250, 251, 1);
  background-color: rgba(249, 250, 251, var(--tw-bg-opacity, 1));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(92, 101, 116, 1);
  background-color: rgba(92, 101, 116, var(--tw-bg-opacity, 1));
}
.bg-gray-500\\/10 {
  background-color: rgba(92, 101, 116, 0.1);
}
.bg-gray-500\\/20 {
  background-color: rgba(92, 101, 116, 0.2);
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 65, 81, 1);
  background-color: rgba(55, 65, 81, var(--tw-bg-opacity, 1));
}
.bg-green {
  --tw-bg-opacity: 1;
  background-color: rgba(27, 196, 125, 1);
  background-color: rgba(27, 196, 125, var(--tw-bg-opacity, 1));
}
.bg-green\\/90 {
  background-color: rgba(27, 196, 125, 0.9);
}
.bg-grey {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 245, 248, 1);
  background-color: rgba(242, 245, 248, var(--tw-bg-opacity, 1));
}
.bg-neutral-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 245, 245, 1);
  background-color: rgba(245, 245, 245, var(--tw-bg-opacity, 1));
}
.bg-red {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 72, 34, 1);
  background-color: rgba(242, 72, 34, var(--tw-bg-opacity, 1));
}
.bg-red\\/10 {
  background-color: rgba(242, 72, 34, 0.1);
}
.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgba(11, 17, 24, 1);
  background-color: rgba(11, 17, 24, var(--tw-bg-opacity, 1));
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(241, 245, 249, 1);
  background-color: rgba(241, 245, 249, var(--tw-bg-opacity, 1));
}
.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(226, 232, 240, 1);
  background-color: rgba(226, 232, 240, var(--tw-bg-opacity, 1));
}
.bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgba(203, 213, 225, 1);
  background-color: rgba(203, 213, 225, var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}
.bg-white\\/50 {
  background-color: rgba(255, 255, 255, 0.5);
}
.bg-white\\/80 {
  background-color: rgba(255, 255, 255, 0.8);
}
.bg-white\\/85 {
  background-color: rgba(255, 255, 255, 0.85);
}
.bg-yellow {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 199, 0, 1);
  background-color: rgba(255, 199, 0, var(--tw-bg-opacity, 1));
}
.\\!bg-opacity-100 {
  --tw-bg-opacity: 1 !important;
}
.\\!bg-opacity-50 {
  --tw-bg-opacity: 0.5 !important;
}
.bg-opacity-0 {
  --tw-bg-opacity: 0;
}
.bg-opacity-10 {
  --tw-bg-opacity: 0.1;
}
.bg-opacity-100 {
  --tw-bg-opacity: 1;
}
.bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}
.bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-opacity-5 {
  --tw-bg-opacity: 0.05;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-75 {
  --tw-bg-opacity: 0.75;
}
.bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.bg-opacity-90 {
  --tw-bg-opacity: 0.9;
}
.bg-opacity-\\[0\\.85\\] {
  --tw-bg-opacity: 0.85;
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-bl {
  background-image: linear-gradient(to bottom left, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.\\!from-\\[\\#169C64\\] {
  --tw-gradient-from: #169C64 var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgba(22, 156, 100, 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.\\!from-\\[\\#D5F5CC4D\\] {
  --tw-gradient-from: rgba(213,245,204,0.30196) var(--tw-gradient-from-position) !important;
  --tw-gradient-to: rgba(213, 245, 204, 0) var(--tw-gradient-to-position) !important;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.from-\\[\\#1DB95C00\\] {
  --tw-gradient-from: rgba(29,185,92,0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(29, 185, 92, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#374FD51A\\] {
  --tw-gradient-from: rgba(55,79,213,0.10196) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 79, 213, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#5A87BF26\\] {
  --tw-gradient-from: rgba(90,135,191,0.14902) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 135, 191, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#5A87BFCC\\] {
  --tw-gradient-from: rgba(90,135,191,0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(90, 135, 191, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#D5F5CC\\] {
  --tw-gradient-from: #D5F5CC var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(213, 245, 204, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#D7E6FA\\] {
  --tw-gradient-from: #D7E6FA var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(215, 230, 250, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F2482200\\] {
  --tw-gradient-from: rgba(242,72,34,0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(242, 72, 34, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[var\\(--figma-color-bg\\)\\] {
  --tw-gradient-from: var(--figma-color-bg) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 255, 255, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-accent\\/15 {
  --tw-gradient-from: rgba(55, 79, 213, 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(55, 79, 213, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[var\\(--figma-color-bg\\)\\] {
  --tw-gradient-to: rgba(255, 255, 255, 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--figma-color-bg) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.\\!to-\\[\\#1BC47D\\] {
  --tw-gradient-to: #1BC47D var(--tw-gradient-to-position) !important;
}
.\\!to-\\[\\#D7E6FA4D\\] {
  --tw-gradient-to: rgba(215,230,250,0.30196) var(--tw-gradient-to-position) !important;
}
.to-\\[\\#1DB95C1A\\] {
  --tw-gradient-to: rgba(29,185,92,0.10196) var(--tw-gradient-to-position);
}
.to-\\[\\#5A87BF26\\] {
  --tw-gradient-to: rgba(90,135,191,0.14902) var(--tw-gradient-to-position);
}
.to-\\[\\#5A87BF66\\] {
  --tw-gradient-to: rgba(90,135,191,0.4) var(--tw-gradient-to-position);
}
.to-\\[\\#94CFFA\\] {
  --tw-gradient-to: #94CFFA var(--tw-gradient-to-position);
}
.to-\\[\\#D7E6FA00\\] {
  --tw-gradient-to: rgba(215,230,250,0) var(--tw-gradient-to-position);
}
.to-\\[\\#D7E6FA\\] {
  --tw-gradient-to: #D7E6FA var(--tw-gradient-to-position);
}
.to-\\[\\#F248221A\\] {
  --tw-gradient-to: rgba(242,72,34,0.10196) var(--tw-gradient-to-position);
}
.to-\\[\\#FFFFFF00\\] {
  --tw-gradient-to: rgba(255,255,255,0) var(--tw-gradient-to-position);
}
.to-accent\\/5 {
  --tw-gradient-to: rgba(55, 79, 213, 0.05) var(--tw-gradient-to-position);
}
.\\!fill-black {
  fill: #000 !important;
}
.\\!fill-white {
  fill: #fff !important;
}
.fill-\\[\\#18A0FB\\] {
  fill: #18A0FB;
}
.fill-\\[\\#5A87BF0F\\] {
  fill: rgba(90,135,191,0.05882);
}
.fill-\\[\\#D9D9D9\\] {
  fill: #D9D9D9;
}
.fill-\\[var\\(--highlight-color\\)\\] {
  fill: var(--highlight-color);
}
.fill-\\[var\\(--highlight-tint-color\\)\\] {
  fill: var(--highlight-tint-color);
}
.fill-accent {
  fill: #374FD5;
}
.fill-black {
  fill: #000;
}
.fill-blue-600 {
  fill: #2563eb;
}
.fill-gray-400 {
  fill: #89909A;
}
.fill-secondary {
  fill: #0B1118;
}
.\\!stroke-\\[white\\] {
  stroke: white !important;
}
.\\!stroke-gray-500 {
  stroke: #5C6574 !important;
}
.\\!stroke-white {
  stroke: #fff !important;
}
.stroke-\\[\\#0B1118\\] {
  stroke: #0B1118;
}
.stroke-\\[\\#1DB95C\\] {
  stroke: #1DB95C;
}
.stroke-\\[\\#5A87BF1F\\] {
  stroke: rgba(90,135,191,0.12157);
}
.stroke-\\[\\#89909A\\] {
  stroke: #89909A;
}
.stroke-\\[\\#E6EAED\\] {
  stroke: #E6EAED;
}
.stroke-\\[\\#F24822\\] {
  stroke: #F24822;
}
.stroke-\\[url\\(\\#stroke-gradient\\)\\] {
  stroke: url(#stroke-gradient);
}
.stroke-\\[var\\(--currentColor\\)\\] {
  stroke: var(--currentColor);
}
.stroke-black {
  stroke: #000;
}
.stroke-gray-100 {
  stroke: #F5F6F8;
}
.stroke-gray-300 {
  stroke: #CED3D9;
}
.stroke-gray-400 {
  stroke: #89909A;
}
.stroke-gray-500 {
  stroke: #5C6574;
}
.stroke-gray-900 {
  stroke: #111827;
}
.stroke-red {
  stroke: #F24822;
}
.stroke-secondary {
  stroke: #0B1118;
}
.stroke-white {
  stroke: #fff;
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.object-fill {
  -o-object-fit: fill;
     object-fit: fill;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-16 {
  padding: 4rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[20px\\] {
  padding: 20px;
}
.p-\\[2px\\] {
  padding: 2px;
}
.\\!px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!py-1\\.5 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[2px\\] {
  padding-left: 2px;
  padding-right: 2px;
}
.px-\\[4px\\] {
  padding-left: 4px;
  padding-right: 4px;
}
.px-\\[5px\\] {
  padding-left: 5px;
  padding-right: 5px;
}
.px-\\[6px\\] {
  padding-left: 6px;
  padding-right: 6px;
}
.px-\\[9\\.5px\\] {
  padding-left: 9.5px;
  padding-right: 9.5px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-28 {
  padding-top: 7rem;
  padding-bottom: 7rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[18px\\] {
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[40px\\] {
  padding-top: 40px;
  padding-bottom: 40px;
}
.py-\\[4px\\] {
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[5\\%\\] {
  padding-top: 5%;
  padding-bottom: 5%;
}
.py-\\[6\\.5px\\] {
  padding-top: 6.5px;
  padding-bottom: 6.5px;
}
.py-\\[6px\\] {
  padding-top: 6px;
  padding-bottom: 6px;
}
.py-\\[7px\\] {
  padding-top: 7px;
  padding-bottom: 7px;
}
.py-\\[8px\\] {
  padding-top: 8px;
  padding-bottom: 8px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[100px\\] {
  padding-bottom: 100px;
}
.pb-\\[4px\\] {
  padding-bottom: 4px;
}
.pl-0 {
  padding-left: 0px;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-\\[2px\\] {
  padding-left: 2px;
}
.pl-\\[4px\\] {
  padding-left: 4px;
}
.pl-\\[6px\\] {
  padding-left: 6px;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-\\[10px\\] {
  padding-right: 10px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-\\[1px\\] {
  padding-top: 1px;
}
.pt-\\[20vh\\] {
  padding-top: 20vh;
}
.pt-\\[3px\\] {
  padding-top: 3px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-middle {
  vertical-align: middle;
}
.font-body {
  font-family: -apple-system, BlinkMacSystemFont, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Segoe UI", Roboto, Ubuntu;
}
.font-header {
  font-family: -apple-system, BlinkMacSystemFont, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Segoe UI", Roboto, Ubuntu;
}
.font-mono {
  font-family: "DM Mono";
}
.\\!text-\\[14px\\] {
  font-size: 14px !important;
}
.\\!text-lg {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.\\!text-sm {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[1\\.25rem\\] {
  font-size: 1.25rem;
}
.text-\\[1\\.5rem\\] {
  font-size: 1.5rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[12px\\]\\/\\[14px\\] {
  font-size: 12px;
  line-height: 14px;
}
.text-\\[12px\\]\\/\\[16px\\] {
  font-size: 12px;
  line-height: 16px;
}
.text-\\[13px\\]\\/\\[14px\\] {
  font-size: 13px;
  line-height: 14px;
}
.text-\\[13px\\]\\/\\[20px\\] {
  font-size: 13px;
  line-height: 20px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[14px\\]\\/\\[24px\\] {
  font-size: 14px;
  line-height: 24px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[2\\.5rem\\] {
  font-size: 2.5rem;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-\\[3\\.5rem\\] {
  font-size: 3.5rem;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[4\\.5rem\\] {
  font-size: 4.5rem;
}
.text-\\[40px\\] {
  font-size: 40px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-sm\\/\\[14px\\] {
  font-size: 0.875rem;
  line-height: 14px;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\!font-medium {
  font-weight: 500 !important;
}
.\\!font-normal {
  font-weight: 400 !important;
}
.\\!font-semibold {
  font-weight: 600 !important;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) tabular-nums var(--tw-numeric-fraction);
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-3 {
  line-height: .75rem;
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-\\[1\\.75rem\\] {
  line-height: 1.75rem;
}
.leading-\\[14px\\] {
  line-height: 14px;
}
.leading-\\[16px\\] {
  line-height: 16px;
}
.leading-\\[23px\\] {
  line-height: 23px;
}
.leading-\\[2rem\\] {
  line-height: 2rem;
}
.leading-\\[3\\.25rem\\] {
  line-height: 3.25rem;
}
.leading-\\[30px\\] {
  line-height: 30px;
}
.leading-\\[36px\\] {
  line-height: 36px;
}
.leading-\\[4rem\\] {
  line-height: 4rem;
}
.leading-\\[5rem\\] {
  line-height: 5rem;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-tight {
  line-height: 1.25;
}
.-tracking-wide {
  letter-spacing: -0.025em;
}
.tracking-\\[0\\.5\\%\\] {
  letter-spacing: 0.5%;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgba(0, 0, 0, 1) !important;
  color: rgba(0, 0, 0, var(--tw-text-opacity, 1)) !important;
}
.\\!text-gray-700 {
  --tw-text-opacity: 1 !important;
  color: rgba(55, 65, 81, 1) !important;
  color: rgba(55, 65, 81, var(--tw-text-opacity, 1)) !important;
}
.\\!text-red {
  --tw-text-opacity: 1 !important;
  color: rgba(242, 72, 34, 1) !important;
  color: rgba(242, 72, 34, var(--tw-text-opacity, 1)) !important;
}
.\\!text-secondary {
  --tw-text-opacity: 1 !important;
  color: rgba(11, 17, 24, 1) !important;
  color: rgba(11, 17, 24, var(--tw-text-opacity, 1)) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgba(255, 255, 255, 1) !important;
  color: rgba(255, 255, 255, var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#0000004D\\] {
  color: rgba(0,0,0,0.30196);
}
.text-\\[\\#0B1118\\] {
  --tw-text-opacity: 1;
  color: rgba(11, 17, 24, 1);
  color: rgba(11, 17, 24, var(--tw-text-opacity, 1));
}
.text-\\[\\#18A0FB\\] {
  --tw-text-opacity: 1;
  color: rgba(24, 160, 251, 1);
  color: rgba(24, 160, 251, var(--tw-text-opacity, 1));
}
.text-\\[\\#1DB95C\\] {
  --tw-text-opacity: 1;
  color: rgba(29, 185, 92, 1);
  color: rgba(29, 185, 92, var(--tw-text-opacity, 1));
}
.text-\\[\\#374FD5\\] {
  --tw-text-opacity: 1;
  color: rgba(55, 79, 213, 1);
  color: rgba(55, 79, 213, var(--tw-text-opacity, 1));
}
.text-\\[\\#787878\\] {
  --tw-text-opacity: 1;
  color: rgba(120, 120, 120, 1);
  color: rgba(120, 120, 120, var(--tw-text-opacity, 1));
}
.text-\\[\\#788FAC\\] {
  --tw-text-opacity: 1;
  color: rgba(120, 143, 172, 1);
  color: rgba(120, 143, 172, var(--tw-text-opacity, 1));
}
.text-\\[\\#89909A\\] {
  --tw-text-opacity: 1;
  color: rgba(137, 144, 154, 1);
  color: rgba(137, 144, 154, var(--tw-text-opacity, 1));
}
.text-\\[\\#CED3D9\\] {
  --tw-text-opacity: 1;
  color: rgba(206, 211, 217, 1);
  color: rgba(206, 211, 217, var(--tw-text-opacity, 1));
}
.text-\\[\\#F24822\\] {
  --tw-text-opacity: 1;
  color: rgba(242, 72, 34, 1);
  color: rgba(242, 72, 34, var(--tw-text-opacity, 1));
}
.text-\\[--figma-color-text-secondary\\] {
  color: var(--figma-color-text-secondary);
}
.text-\\[--figma-color-text\\] {
  color: var(--figma-color-text);
}
.text-\\[var\\(--figma-color-icon-onselected-secondary\\)\\] {
  color: var(--figma-color-icon-onselected-secondary);
}
.text-\\[var\\(--figma-color-text\\)\\] {
  color: var(--figma-color-text);
}
.text-\\[var\\(--highlight-color\\)\\] {
  color: var(--highlight-color);
}
.text-accent {
  --tw-text-opacity: 1;
  color: rgba(55, 79, 213, 1);
  color: rgba(55, 79, 213, var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity, 1));
}
.text-black\\/40 {
  color: rgba(0, 0, 0, 0.4);
}
.text-black\\/80 {
  color: rgba(0, 0, 0, 0.8);
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgba(59, 130, 246, 1);
  color: rgba(59, 130, 246, var(--tw-text-opacity, 1));
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgba(245, 246, 248, 1);
  color: rgba(245, 246, 248, var(--tw-text-opacity, 1));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgba(230, 234, 237, 1);
  color: rgba(230, 234, 237, var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgba(206, 211, 217, 1);
  color: rgba(206, 211, 217, var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgba(137, 144, 154, 1);
  color: rgba(137, 144, 154, var(--tw-text-opacity, 1));
}
.text-gray-400\\/70 {
  color: rgba(137, 144, 154, 0.7);
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgba(92, 101, 116, 1);
  color: rgba(92, 101, 116, var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, 1);
  color: rgba(17, 24, 39, var(--tw-text-opacity, 1));
}
.text-green {
  --tw-text-opacity: 1;
  color: rgba(27, 196, 125, 1);
  color: rgba(27, 196, 125, var(--tw-text-opacity, 1));
}
.text-neutral-400 {
  --tw-text-opacity: 1;
  color: rgba(163, 163, 163, 1);
  color: rgba(163, 163, 163, var(--tw-text-opacity, 1));
}
.text-red {
  --tw-text-opacity: 1;
  color: rgba(242, 72, 34, 1);
  color: rgba(242, 72, 34, var(--tw-text-opacity, 1));
}
.text-secondary {
  --tw-text-opacity: 1;
  color: rgba(11, 17, 24, 1);
  color: rgba(11, 17, 24, var(--tw-text-opacity, 1));
}
.text-secondary\\/70 {
  color: rgba(11, 17, 24, 0.7);
}
.text-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity, 1));
}
.text-yellow {
  --tw-text-opacity: 1;
  color: rgba(255, 199, 0, 1);
  color: rgba(255, 199, 0, var(--tw-text-opacity, 1));
}
.text-opacity-30 {
  --tw-text-opacity: 0.3;
}
.text-opacity-80 {
  --tw-text-opacity: 0.8;
}
.underline {
  text-decoration-line: underline;
}
.\\!opacity-0 {
  opacity: 0 !important;
}
.\\!opacity-100 {
  opacity: 1 !important;
}
.\\!opacity-30 {
  opacity: 0.3 !important;
}
.opacity-0 {
  opacity: 0;
}
.opacity-10 {
  opacity: 0.1;
}
.opacity-100 {
  opacity: 1;
}
.opacity-15 {
  opacity: 0.15;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-5 {
  opacity: 0.05;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.bg-blend-exclusion {
  background-blend-mode: exclusion;
}
.\\!shadow {
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1) !important;
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-\\[0px_2px_6px_rgba\\(255\\2c 158\\2c 0\\2c 0\\.35\\)\\2c 0px_8px_20px_rgba\\(255\\2c 158\\2c 0\\2c 0\\.15\\)\\] {
  --tw-shadow: 0px 2px 6px rgba(255,158,0,0.35),0px 8px 20px rgba(255,158,0,0.15);
  --tw-shadow-colored: 0px 2px 6px var(--tw-shadow-color), 0px 8px 20px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0px 2px 6px rgba(255,158,0,0.35),0px 8px 20px rgba(255,158,0,0.15);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), inset 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-\\[\\#00034E\\]\\/20 {
  --tw-shadow-color: rgba(0, 3, 78, 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[\\#4FB5FA55\\] {
  --tw-shadow-color: rgba(79,181,250,0.33333);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[\\#5A87BF4D\\] {
  --tw-shadow-color: rgba(90,135,191,0.30196);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-inset {
  --tw-ring-inset: inset;
}
.\\!ring-gray-800 {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgba(31, 41, 55, var(--tw-ring-opacity, 1)) !important;
}
.ring-\\[\\#505A621A\\] {
  --tw-ring-color: rgba(80,90,98,0.10196);
}
.ring-\\[\\#f5f5f5\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(245, 245, 245, var(--tw-ring-opacity, 1));
}
.ring-accent {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(55, 79, 213, var(--tw-ring-opacity, 1));
}
.ring-accent\\/50 {
  --tw-ring-color: rgba(55, 79, 213, 0.5);
}
.ring-gray-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(230, 234, 237, var(--tw-ring-opacity, 1));
}
.ring-gray-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(206, 211, 217, var(--tw-ring-opacity, 1));
}
.ring-red {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(242, 72, 34, var(--tw-ring-opacity, 1));
}
.ring-secondary {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(11, 17, 24, var(--tw-ring-opacity, 1));
}
.ring-opacity-80 {
  --tw-ring-opacity: 0.8;
}
.\\!blur {
  --tw-blur: blur(8px) !important;
  filter: blur(8px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.blur {
  --tw-blur: blur(8px);
  filter: blur(8px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-2xl {
  --tw-blur: blur(40px);
  filter: blur(40px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl {
  --tw-blur: blur(64px);
  filter: blur(64px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[120px\\] {
  --tw-blur: blur(120px);
  filter: blur(120px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl {
  --tw-blur: blur(24px);
  filter: blur(24px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 1px 1px rgba(0, 0, 0, 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 1px 1px rgba(0, 0, 0, 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-lg {
  --tw-drop-shadow: drop-shadow(0 10px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0 4px 3px rgba(0, 0, 0, 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(0 10px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0 4px 3px rgba(0, 0, 0, 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) grayscale(100%) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) invert(100%) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.saturate-0 {
  --tw-saturate: saturate(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) saturate(0) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  -webkit-backdrop-filter: blur(8px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: blur(8px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  -webkit-backdrop-filter: blur(16px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: blur(16px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  -webkit-backdrop-filter: blur(12px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: blur(12px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: blur(4px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: blur(4px) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\\!transition-transform {
  transition-property: transform !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[border-radius\\] {
  transition-property: border-radius;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[box-shadow\\2c opacity\\] {
  transition-property: box-shadow,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[left\\2c _to\\2c _transform\\2c _shadow\\] {
  transition-property: left, to, transform, shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[max-height\\] {
  transition-property: max-height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[opacity\\2c transform\\] {
  transition-property: opacity,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c opacity\\] {
  transition-property: transform,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-none {
  transition-property: none;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.\\!delay-0 {
  transition-delay: 0s !important;
}
.delay-0 {
  transition-delay: 0s;
}
.delay-100 {
  transition-delay: 100ms;
}
.delay-1000 {
  transition-delay: 1000ms;
}
.delay-150 {
  transition-delay: 150ms;
}
.delay-200 {
  transition-delay: 200ms;
}
.delay-75 {
  transition-delay: 75ms;
}
.delay-\\[25ms\\] {
  transition-delay: 25ms;
}
.delay-\\[var\\(--arrow-head-transition-delay\\)\\] {
  transition-delay: var(--arrow-head-transition-delay);
}
.\\!duration-150 {
  transition-duration: 150ms !important;
}
.\\!duration-300 {
  transition-duration: 300ms !important;
}
.\\!duration-\\[var\\(--transition-duration\\)\\] {
  transition-duration: var(--transition-duration) !important;
}
.duration-0 {
  transition-duration: 0s;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.duration-75 {
  transition-duration: 75ms;
}
.duration-\\[var\\(--durationMs\\)\\] {
  transition-duration: var(--durationMs);
}
.duration-\\[var\\(--transition-duration\\)\\] {
  transition-duration: var(--transition-duration);
}
.\\!ease-\\[0\\2c 0\\2c 0\\.15\\2c 1\\] {
  transition-timing-function: 0,0,0.15,1 !important;
}
.ease-\\[0\\.5\\2c 0\\.35\\2c 1\\2c 1\\] {
  transition-timing-function: 0.5,0.35,1,1;
}
.ease-\\[cubic-bezier\\(0\\.5\\2c 0\\.35\\2c 0\\.15\\2c 1\\)\\] {
  transition-timing-function: cubic-bezier(0.5,0.35,0.15,1);
}
.ease-\\[cubic-bezier\\(0\\.85\\2c 0\\2c 0\\.15\\2c 1\\)\\] {
  transition-timing-function: cubic-bezier(0.85,0,0.15,1);
}
.ease-\\[var\\(--transition-graph\\)\\] {
  transition-timing-function: var(--transition-graph);
}
.ease-in {
  transition-timing-function: cubic-bezier(0.5, 0.35, 0.1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0.5, 0, 0.15, 1);
}
.txt-\\[11_14_400\\] {
  font-size: 11px;
  line-height: 14px;
  font-weight: 400;
}
.txt-\\[11_16_500\\] {
  font-size: 11px;
  line-height: 16px;
  font-weight: 500;
}
.txt-\\[12_16_400\\] {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
}
.txt-\\[12_16_500\\] {
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
}
.txt-\\[12_16_600\\] {
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
}
.txt-\\[12_20_400\\] {
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
}
.txt-\\[14_18_400\\] {
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
}
.txt-\\[14_18_600\\] {
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
}
.txt-\\[14_20_400\\] {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}
.txt-\\[14_20_500\\] {
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
}
.txt-\\[14_20_510\\] {
  font-size: 14px;
  line-height: 20px;
  font-weight: 510;
}
.txt-\\[14_24_400\\] {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
}
.txt-\\[16_18_400\\] {
  font-size: 16px;
  line-height: 18px;
  font-weight: 400;
}
.txt-\\[16_23_400\\] {
  font-size: 16px;
  line-height: 23px;
  font-weight: 400;
}
.txt-\\[16_24_400\\] {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
}
.txt-\\[18_24_600\\] {
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
}
.txt-\\[18_26_500\\] {
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
}
.txt-\\[24_28_600\\] {
  font-size: 24px;
  line-height: 28px;
  font-weight: 600;
}
.txt-\\[24_32_700\\] {
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
}
.txt-\\[28_32_700\\] {
  font-size: 28px;
  line-height: 32px;
  font-weight: 700;
}
.txt-\\[32_32_590\\] {
  font-size: 32px;
  line-height: 32px;
  font-weight: 590;
}
.txt-\\[36_40_700\\] {
  font-size: 36px;
  line-height: 40px;
  font-weight: 700;
}
.txt-\\[8_8_700\\] {
  font-size: 8px;
  line-height: 8px;
  font-weight: 700;
}
@font-face {
  font-weight: 700;
  font-family: 'Euclid Circular A';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-display: auto;
}
@font-face {
  font-weight: 600;
  font-family: 'Euclid Circular A';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-display: auto;
}
@font-face {
  font-weight: 500;
  font-family: 'Graphik LCG';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-display: auto;
}
@font-face {
  font-weight: 400;
  font-family: 'Graphik LCG';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-display: auto;
}
.selection\\:bg-\\[\\#374FD5\\] *::-moz-selection {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 79, 213, 1);
  background-color: rgba(55, 79, 213, var(--tw-bg-opacity, 1));
}
.selection\\:bg-\\[\\#374FD5\\] *::selection {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 79, 213, 1);
  background-color: rgba(55, 79, 213, var(--tw-bg-opacity, 1));
}
.selection\\:text-white *::-moz-selection {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity, 1));
}
.selection\\:text-white *::selection {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity, 1));
}
.selection\\:bg-\\[\\#374FD5\\]::-moz-selection {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 79, 213, 1);
  background-color: rgba(55, 79, 213, var(--tw-bg-opacity, 1));
}
.selection\\:bg-\\[\\#374FD5\\]::selection {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 79, 213, 1);
  background-color: rgba(55, 79, 213, var(--tw-bg-opacity, 1));
}
.selection\\:text-white::-moz-selection {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity, 1));
}
.selection\\:text-white::selection {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity, 1));
}
.placeholder\\:text-gray-400::-moz-placeholder {
  --tw-text-opacity: 1;
  color: rgba(137, 144, 154, 1);
  color: rgba(137, 144, 154, var(--tw-text-opacity, 1));
}
.placeholder\\:text-gray-400::placeholder {
  --tw-text-opacity: 1;
  color: rgba(137, 144, 154, 1);
  color: rgba(137, 144, 154, var(--tw-text-opacity, 1));
}
.invalid\\:\\!border-red:invalid {
  --tw-border-opacity: 1 !important;
  border-color: rgba(242, 72, 34, 1) !important;
  border-color: rgba(242, 72, 34, var(--tw-border-opacity, 1)) !important;
}
.focus-within\\:ring-1:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.hover\\:z-30:hover {
  z-index: 30;
}
.hover\\:z-50:hover {
  z-index: 50;
}
.hover\\:\\!scale-\\[1\\.1\\]:hover {
  --tw-scale-x: 1.1 !important;
  --tw-scale-y: 1.1 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.1) scaleY(1.1) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.05) scaleY(1.05);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.01\\]:hover {
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.01) scaleY(1.01);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.02\\]:hover {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.02) scaleY(1.02);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:cursor-default:hover {
  cursor: default;
}
.hover\\:cursor-ew-resize:hover {
  cursor: ew-resize;
}
.hover\\:cursor-pointer:hover {
  cursor: pointer;
}
.hover\\:overflow-auto:hover {
  overflow: auto;
}
.hover\\:\\!border-\\[\\#B22A0C\\]:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgba(178, 42, 12, 1) !important;
  border-color: rgba(178, 42, 12, var(--tw-border-opacity, 1)) !important;
}
.hover\\:\\!border-secondary:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgba(11, 17, 24, 1) !important;
  border-color: rgba(11, 17, 24, var(--tw-border-opacity, 1)) !important;
}
.hover\\:border-\\[\\#0079CA\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgba(0, 121, 202, 1);
  border-color: rgba(0, 121, 202, var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#C7C7C7\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgba(199, 199, 199, 1);
  border-color: rgba(199, 199, 199, var(--tw-border-opacity, 1));
}
.hover\\:border-\\[var\\(--highlight-hover-color\\)\\]:hover {
  border-color: var(--highlight-hover-color);
}
.hover\\:border-red\\/20:hover {
  border-color: rgba(242, 72, 34, 0.2);
}
.hover\\:\\!bg-\\[\\#6767674d\\]:hover {
  background-color: rgba(103,103,103,0.30196) !important;
}
.hover\\:bg-\\[\\#18B071\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(24, 176, 113, 1);
  background-color: rgba(24, 176, 113, var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[--figma-color-bg-onselected-hover\\]:hover {
  background-color: var(--figma-color-bg-onselected-hover);
}
.hover\\:bg-accent:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 79, 213, 1);
  background-color: rgba(55, 79, 213, var(--tw-bg-opacity, 1));
}
.hover\\:bg-accent\\/10:hover {
  background-color: rgba(55, 79, 213, 0.1);
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 246, 248, 1);
  background-color: rgba(245, 246, 248, var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(230, 234, 237, 1);
  background-color: rgba(230, 234, 237, var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(206, 211, 217, 1);
  background-color: rgba(206, 211, 217, var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-500\\/20:hover {
  background-color: rgba(92, 101, 116, 0.2);
}
.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(31, 41, 55, 1);
  background-color: rgba(31, 41, 55, var(--tw-bg-opacity, 1));
}
.hover\\:bg-red\\/10:hover {
  background-color: rgba(242, 72, 34, 0.1);
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}
.hover\\:bg-opacity-100:hover {
  --tw-bg-opacity: 1;
}
.hover\\:bg-opacity-20:hover {
  --tw-bg-opacity: 0.2;
}
.hover\\:bg-opacity-5:hover {
  --tw-bg-opacity: 0.05;
}
.hover\\:bg-opacity-50:hover {
  --tw-bg-opacity: 0.5;
}
.hover\\:bg-opacity-\\[15\\%\\]:hover {
  --tw-bg-opacity: 15%;
}
.hover\\:text-accent:hover {
  --tw-text-opacity: 1;
  color: rgba(55, 79, 213, 1);
  color: rgba(55, 79, 213, var(--tw-text-opacity, 1));
}
.hover\\:text-red:hover {
  --tw-text-opacity: 1;
  color: rgba(242, 72, 34, 1);
  color: rgba(242, 72, 34, var(--tw-text-opacity, 1));
}
.hover\\:\\!opacity-100:hover {
  opacity: 1 !important;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-70:hover {
  opacity: 0.7;
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.hover\\:opacity-90:hover {
  opacity: 0.9;
}
.hover\\:\\!shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.hover\\:ring-gray-400:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(137, 144, 154, var(--tw-ring-opacity, 1));
}
.hover\\:duration-150:hover {
  transition-duration: 150ms;
}
.hover\\:ease-in:hover {
  transition-timing-function: cubic-bezier(0.5, 0.35, 0.1, 1);
}
.focus\\:scale-\\[1\\.02\\]:focus {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.02) scaleY(1.02);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.focus\\:border-\\[var\\(--highlight-color\\)\\]:focus {
  border-color: var(--highlight-color);
}
.focus\\:border-transparent:focus {
  border-color: transparent;
}
.focus\\:shadow-md:focus {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus\\:ring-accent:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(55, 79, 213, var(--tw-ring-opacity, 1));
}
.active\\:border-\\[\\#0079CA\\]:active {
  --tw-border-opacity: 1;
  border-color: rgba(0, 121, 202, 1);
  border-color: rgba(0, 121, 202, var(--tw-border-opacity, 1));
}
.active\\:border-\\[\\#C7C7C7\\]:active {
  --tw-border-opacity: 1;
  border-color: rgba(199, 199, 199, 1);
  border-color: rgba(199, 199, 199, var(--tw-border-opacity, 1));
}
.active\\:border-\\[var\\(--highlight-active-color\\)\\]:active {
  border-color: var(--highlight-active-color);
}
.active\\:\\!bg-\\[\\#B22A0C\\]:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(178, 42, 12, 1) !important;
  background-color: rgba(178, 42, 12, var(--tw-bg-opacity, 1)) !important;
}
.active\\:\\!bg-accent\\/50:active {
  background-color: rgba(55, 79, 213, 0.5) !important;
}
.active\\:bg-\\[\\#0079CA\\]:active {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 121, 202, 1);
  background-color: rgba(0, 121, 202, var(--tw-bg-opacity, 1));
}
.active\\:bg-\\[\\#169D64\\]:active {
  --tw-bg-opacity: 1;
  background-color: rgba(22, 157, 100, 1);
  background-color: rgba(22, 157, 100, var(--tw-bg-opacity, 1));
}
.active\\:bg-\\[\\#C7C7C7\\]:active {
  --tw-bg-opacity: 1;
  background-color: rgba(199, 199, 199, 1);
  background-color: rgba(199, 199, 199, var(--tw-bg-opacity, 1));
}
.active\\:bg-\\[var\\(--highlight-active-color\\)\\]:active {
  background-color: var(--highlight-active-color);
}
.active\\:bg-accent\\/50:active {
  background-color: rgba(55, 79, 213, 0.5);
}
.active\\:bg-green\\/50:active {
  background-color: rgba(27, 196, 125, 0.5);
}
.active\\:bg-red\\/50:active {
  background-color: rgba(242, 72, 34, 0.5);
}
.active\\:bg-transparent:active {
  background-color: transparent;
}
.active\\:opacity-80:active {
  opacity: 0.8;
}
.enabled\\:hover\\:bg-\\[\\#18B071\\]:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgba(24, 176, 113, 1);
  background-color: rgba(24, 176, 113, var(--tw-bg-opacity, 1));
}
.enabled\\:active\\:bg-\\[\\#169D64\\]:active:enabled {
  --tw-bg-opacity: 1;
  background-color: rgba(22, 157, 100, 1);
  background-color: rgba(22, 157, 100, var(--tw-bg-opacity, 1));
}
.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.disabled\\:animate-pulse:disabled {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.disabled\\:cursor-no-drop:disabled {
  cursor: no-drop;
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:bg-gray-300:disabled {
  --tw-bg-opacity: 1;
  background-color: rgba(206, 211, 217, 1);
  background-color: rgba(206, 211, 217, var(--tw-bg-opacity, 1));
}
.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
.disabled\\:opacity-70:disabled {
  opacity: 0.7;
}
.disabled\\:opacity-80:disabled {
  opacity: 0.8;
}
.group:hover .group-hover\\:visible {
  visibility: visible;
}
.group:hover .group-hover\\:invisible {
  visibility: hidden;
}
.group:hover .group-hover\\:-left-\\[24px\\] {
  left: -24px;
}
.group:hover .group-hover\\:-top-\\[24px\\] {
  top: -24px;
}
.group:hover .group-hover\\:left-\\[24px\\] {
  left: 24px;
}
.group:hover .group-hover\\:left-\\[78px\\] {
  left: 78px;
}
.group:hover .group-hover\\:top-\\[24px\\] {
  top: 24px;
}
.group:hover .group-hover\\:top-\\[76px\\] {
  top: 76px;
}
.group:hover .group-hover\\:m-0 {
  margin: 0px;
}
.group:hover .group-hover\\:ml-1 {
  margin-left: 0.25rem;
}
.group:hover .group-hover\\:h-5 {
  height: 1.25rem;
}
.group:hover .group-hover\\:h-6 {
  height: 1.5rem;
}
.group:hover .group-hover\\:h-\\[--height\\] {
  height: var(--height);
}
.group:hover .group-hover\\:w-5 {
  width: 1.25rem;
}
.group:hover .group-hover\\:w-6 {
  width: 1.5rem;
}
.group:hover .group-hover\\:w-\\[240px\\] {
  width: 240px;
}
.group:hover .group-hover\\:-translate-x-\\[40px\\] {
  --tw-translate-x: -40px;
  transform: translate(-40px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:-translate-y-10 {
  --tw-translate-y: -2.5rem;
  transform: translate(var(--tw-translate-x), -2.5rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(0.25rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:rotate-12 {
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(12deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.05) scaleY(1.05);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.1) scaleY(1.1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-\\[1\\.01\\] {
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.01) scaleY(1.01);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-x-\\[0\\.65\\] {
  --tw-scale-x: 0.65;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0.65) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:fill-secondary {
  fill: #0B1118;
}
.group:hover .group-hover\\:stroke-black {
  stroke: #000;
}
.group:hover .group-hover\\:stroke-gray-900 {
  stroke: #111827;
}
.group:hover .group-hover\\:stroke-secondary {
  stroke: #0B1118;
}
.group:hover .group-hover\\:p-3 {
  padding: 0.75rem;
}
.group:hover .group-hover\\:px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.group:hover .group-hover\\:text-secondary {
  --tw-text-opacity: 1;
  color: rgba(11, 17, 24, 1);
  color: rgba(11, 17, 24, var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:\\!opacity-10 {
  opacity: 0.1 !important;
}
.group:hover .group-hover\\:opacity-0 {
  opacity: 0;
}
.group:hover .group-hover\\:opacity-10 {
  opacity: 0.1;
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.group:hover .group-hover\\:shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.group:hover .group-hover\\:ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.group:hover .group-hover\\:ring-\\[0\\.5px\\] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0.5px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.group\\/item:hover .group-hover\\/item\\:\\!ring-\\[\\#2f343b\\] {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgba(47, 52, 59, var(--tw-ring-opacity, 1)) !important;
}
.group:hover .group-hover\\:delay-0 {
  transition-delay: 0s;
}
.group:focus .group-focus\\:shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.group:active .group-active\\:opacity-100 {
  opacity: 1;
}
.peer:invalid ~ .peer-invalid\\:bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgba(206, 211, 217, 1);
  background-color: rgba(206, 211, 217, var(--tw-bg-opacity, 1));
}
.has-\\[\\:checked\\]\\:bg-gray-200:has(:checked) {
  --tw-bg-opacity: 1;
  background-color: rgba(230, 234, 237, 1);
  background-color: rgba(230, 234, 237, var(--tw-bg-opacity, 1));
}
.has-\\[\\:invalid\\]\\:text-red:has(:invalid) {
  --tw-text-opacity: 1;
  color: rgba(242, 72, 34, 1);
  color: rgba(242, 72, 34, var(--tw-text-opacity, 1));
}
.has-\\[\\:disabled\\]\\:opacity-0:has(:disabled) {
  opacity: 0;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled) {
  opacity: 0.5;
}
.has-\\[\\:checked\\]\\:ring-2:has(:checked) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.has-\\[\\:checked\\]\\:ring-secondary:has(:checked) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(11, 17, 24, var(--tw-ring-opacity, 1));
}
.group:has(:invalid) .group-has-\\[\\:invalid\\]\\:block {
  display: block;
}
@supports (-webkit-appearance:none) {

  .supports-\\[-webkit-appearance\\:none\\]\\:transition-none {
    transition-property: none;
  }
}
@media (min-width: 640px) {

  .sm\\:absolute {
    position: absolute;
  }

  .sm\\:inset-0 {
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:w-5\\/12 {
    width: 41.666667%;
  }

  .sm\\:w-7\\/12 {
    width: 58.333333%;
  }

  .sm\\:w-\\[120px\\] {
    width: 120px;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-10 {
    gap: 2.5rem;
  }

  .sm\\:p-0 {
    padding: 0px;
  }

  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-\\[110px\\] {
    padding-left: 110px;
    padding-right: 110px;
  }

  .lg\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .lg\\:pl-\\[340px\\] {
    padding-left: 340px;
  }
}
@media (min-width: 1280px) {

  .xl\\:h-full {
    height: 100%;
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:items-start {
    align-items: flex-start;
  }

  .xl\\:gap-0 {
    gap: 0px;
  }

  .xl\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
@media (min-width: 1536px) {

  .\\32xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (min-width: 2000px) {

  .\\33xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
@media (prefers-color-scheme: dark) {

  .dark\\:text-gray-600 {
    --tw-text-opacity: 1;
    color: rgba(75, 85, 99, 1);
    color: rgba(75, 85, 99, var(--tw-text-opacity, 1));
  }
}
.\\[\\&\\:not\\(\\:last-child\\)\\]\\:border-b-\\[1px\\]:not(:last-child) {
  border-bottom-width: 1px;
}
.\\[\\&\\:not\\(\\:last-child\\)\\]\\:border-b-\\[var\\(--aninix-color-foreground-black-05\\)\\]:not(:last-child) {
  border-bottom-color: var(--aninix-color-foreground-black-05);
}
.\\[\\&\\>li\\]\\:flex>li {
  display: flex;
}
.\\[\\&\\>li\\]\\:flex-row>li {
  flex-direction: row;
}
.\\[\\&\\>li\\]\\:items-center>li {
  align-items: center;
}
.\\[\\&\\>li\\]\\:gap-4>li {
  gap: 1rem;
}
.\\[\\&\\>li\\]\\:rounded-\\[8px\\]>li {
  border-radius: 8px;
}
.\\[\\&\\>li\\]\\:border-\\[1px\\]>li {
  border-width: 1px;
}
.\\[\\&\\>li\\]\\:border-solid>li {
  border-style: solid;
}
.\\[\\&\\>li\\]\\:border-\\[\\#1BC47D33\\]>li {
  border-color: rgba(27,196,125,0.2);
}
.\\[\\&\\>li\\]\\:p-4>li {
  padding: 1rem;
}
.\\[\\&\\>p\\]\\:mx-0>p {
  margin-left: 0px;
  margin-right: 0px;
}
.\\[\\&\\>p\\]\\:px-12>p {
  padding-left: 3rem;
  padding-right: 3rem;
}
.\\[\\&\\>span\\>svg\\]\\:\\!h-4>span>svg {
  height: 1rem !important;
}
.\\[\\&\\>span\\>svg\\]\\:\\!w-4>span>svg {
  width: 1rem !important;
}
.\\[\\&\\>span\\>svg\\]\\:\\!rounded-\\[2px\\]>span>svg {
  border-radius: 2px !important;
}
.\\[\\&\\>span\\>svg\\]\\:\\!text-\\[var\\(--\\#b3b3b3\\)\\]>span>svg {
  color: var(--#b3b3b3) !important;
}
.\\[\\&\\>span\\>svg\\]\\:\\!text-\\[var\\(--figma-color-bg-brand\\)\\]>span>svg {
  color: var(--figma-color-bg-brand) !important;
}
`, "",{"version":3,"sources":["webpack://./apps/web-app/src/_input.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,8LAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,0BAAc;EAAd,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,sBAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,YAAmB;EAAnB,cAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,SAAmB;EAAnB,WAAmB;EAAnB,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,qMAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,kLAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,iLAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+KAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+KAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+KAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,kLAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+KAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,iLAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,kLAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,iLAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,gLAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,iLAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,gLAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,gLAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,2LAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,kLAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,gLAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,gLAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,iMAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,8LAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,gMAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,qLAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,qLAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,sLAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,qLAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,oLAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,oLAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,qLAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0BAAmB;EAAnB,0KAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB,+JAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB,+JAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB,iKAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB,mKAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB,mKAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB,mKAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB,qKAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB,qKAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB,mKAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB,mKAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB,qKAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB,mKAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB,mKAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gLAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gLAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,qCAAmB;EAAnB,8DAAmB;EAAnB,yCAAmB;EAAnB,kEAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,iFAAmB;EAAnB;AAAmB;AAAnB;EAAA,yFAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA,mBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,+HAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yFAAmB;EAAnB,yGAAmB;EAAnB,8HAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,8FAAmB;EAAnB,mHAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,4FAAmB;EAAnB,oHAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,mGAAmB;EAAnB,wHAAmB;EAAnB;AAAmB;AAAnB;EAAA,iFAAmB;EAAnB,iGAAmB;EAAnB,sHAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,sCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB,iFAAmB;EAAnB;AAAmB;AAAnB;EAAA,oFAAmB;EAAnB,oGAAmB;EAAnB,yHAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,uLAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,4KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sGAAmB;EAAnB,gPAAmB;EAAnB;AAAmB;AAAnB;EAAA,uGAAmB;EAAnB,iPAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0KAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iQAAmB;EAAnB,+QAAmB;EAAnB,yPAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,kQAAmB;EAAnB,+QAAmB;EAAnB,0PAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,kQAAmB;EAAnB,+QAAmB;EAAnB,0PAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,iQAAmB;EAAnB,+QAAmB;EAAnB,yPAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAEnB;EACE,gBAAgB;EAChB,gCAAgC;EAChC,+DAAsE;EACtE,kBAAkB;AACpB;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,+DAA0E;EAC1E,kBAAkB;AACpB;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,+DAAmE;EACnE,kBAAkB;AACpB;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,+DAAoE;EACpE,kBAAkB;AACpB;AA9BA;EAAA,kBA+BA;EA/BA,sCA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,sCA+BA;EA/BA;AA+BA;AA/BA;EAAA,oBA+BA;EA/BA,6BA+BA;EA/BA;AA+BA;AA/BA;EAAA,oBA+BA;EA/BA,6BA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,sCA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,sCA+BA;EA/BA;AA+BA;AA/BA;EAAA,oBA+BA;EA/BA,6BA+BA;EA/BA;AA+BA;AA/BA;EAAA,oBA+BA;EA/BA,6BA+BA;EA/BA;AA+BA;AA/BA;EAAA,oBA+BA;EA/BA,6BA+BA;EA/BA;AA+BA;AA/BA;EAAA,oBA+BA;EA/BA,6BA+BA;EA/BA;AA+BA;AA/BA;EAAA,iCA+BA;EA/BA,6CA+BA;EA/BA;AA+BA;AA/BA;EAAA,2GA+BA;EA/BA,yGA+BA;EA/BA,kFA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,4BA+BA;EA/BA,4BA+BA;EA/BA,8KA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,kBA+BA;EA/BA,qKA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,kBA+BA;EA/BA,qKA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,kBA+BA;EA/BA,qKA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,iCA+BA;EA/BA,6CA+BA;EA/BA;AA+BA;AA/BA;EAAA,iCA+BA;EA/BA,4CA+BA;EA/BA;AA+BA;AA/BA;EAAA,sBA+BA;EA/BA,kCA+BA;EA/BA;AA+BA;AA/BA;EAAA,sBA+BA;EA/BA,oCA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,uCA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,sCA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,wCA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,wCA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,wCA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,qCA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,wCA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,oBA+BA;EA/BA,2BA+BA;EA/BA;AA+BA;AA/BA;EAAA,oBA+BA;EA/BA,2BA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,+FA+BA;EA/BA,+GA+BA;EA/BA,oIA+BA;EA/BA;AA+BA;AA/BA;EAAA,mFA+BA;EA/BA,mGA+BA;EA/BA,wHA+BA;EA/BA;AA+BA;AA/BA;EAAA,iFA+BA;EA/BA,iGA+BA;EA/BA,sHA+BA;EA/BA;AA+BA;AA/BA;EAAA,oFA+BA;EA/BA,oGA+BA;EA/BA,yHA+BA;EA/BA;AA+BA;AA/BA;EAAA,oBA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,kBA+BA;EA/BA,qKA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,iFA+BA;EA/BA,iGA+BA;EA/BA,sHA+BA;EA/BA;AA+BA;AA/BA;EAAA,8BA+BA;EA/BA;AA+BA;AA/BA;EAAA,2GA+BA;EA/BA,yGA+BA;EA/BA,kFA+BA;EA/BA;AA+BA;AA/BA;EAAA,oBA+BA;EA/BA;AA+BA;AA/BA;EAAA,sBA+BA;EA/BA,kCA+BA;EA/BA;AA+BA;AA/BA;EAAA,sBA+BA;EA/BA,oCA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,6BA+BA;EA/BA,iDA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,sCA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,uCA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,wCA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,uCA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,uCA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;;EAAA;IAAA;EA+BA;AAAA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,wCA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,uBA+BA;EA/BA,+KA+BA;EA/BA;AA+BA;AA/BA;EAAA,yBA+BA;EA/BA,iLA+BA;EA/BA;AA+BA;AA/BA;EAAA,yBA+BA;EA/BA,iLA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,oLA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,kBA+BA;EA/BA,qKA+BA;EA/BA;AA+BA;AA/BA;EAAA,iBA+BA;EA/BA,iBA+BA;EA/BA,mKA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,kBA+BA;EA/BA,qKA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,kLA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,qBA+BA;EA/BA;AA+BA;AA/BA;EAAA,oBA+BA;EA/BA,0BA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,mFA+BA;EA/BA,mGA+BA;EA/BA,wHA+BA;EA/BA;AA+BA;AA/BA;EAAA,2GA+BA;EA/BA,yGA+BA;EA/BA,kFA+BA;EA/BA;AA+BA;AA/BA;EAAA,2GA+BA;EA/BA,2GA+BA;EA/BA,kFA+BA;EA/BA;AA+BA;AA/BA;EAAA,+BA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,mFA+BA;EA/BA,mGA+BA;EA/BA,wHA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,wCA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA,wCA+BA;EA/BA;AA+BA;AA/BA;EAAA,oBA+BA;EA/BA,2BA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,2GA+BA;EA/BA,yGA+BA;EA/BA,kFA+BA;EA/BA;AA+BA;AA/BA;EAAA,oBA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;;EAAA;IAAA;EA+BA;AAAA;AA/BA;;EAAA;IAAA;EA+BA;;EA/BA;IAAA,QA+BA;IA/BA,UA+BA;IA/BA,WA+BA;IA/BA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA,iBA+BA;IA/BA;EA+BA;;EA/BA;IAAA,kBA+BA;IA/BA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA,mBA+BA;IA/BA;EA+BA;AAAA;AA/BA;;EAAA;IAAA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA,iBA+BA;IA/BA;EA+BA;;EA/BA;IAAA,mBA+BA;IA/BA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA;EA+BA;AAAA;AA/BA;;EAAA;IAAA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA;EA+BA;;EA/BA;IAAA,eA+BA;IA/BA;EA+BA;AAAA;AA/BA;;EAAA;IAAA;EA+BA;AAAA;AA/BA;;EAAA;IAAA;EA+BA;AAAA;AA/BA;;EAAA;IAAA,oBA+BA;IA/BA,0BA+BA;IA/BA;EA+BA;AAAA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA,gBA+BA;EA/BA;AA+BA;AA/BA;EAAA,kBA+BA;EA/BA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA;AA/BA;EAAA;AA+BA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@font-face {\n  font-weight: 700;\n  font-family: 'Euclid Circular A';\n  src: url('./styles/fonts/EuclidCircularA-Bold.ttf') format('truetype');\n  font-display: auto;\n}\n\n@font-face {\n  font-weight: 600;\n  font-family: 'Euclid Circular A';\n  src: url('./styles/fonts/EuclidCircularA-SemiBold.ttf') format('truetype');\n  font-display: auto;\n}\n\n@font-face {\n  font-weight: 500;\n  font-family: 'Graphik LCG';\n  src: url('./styles/fonts/GraphikLCG-Medium.ttf') format('truetype');\n  font-display: auto;\n}\n\n@font-face {\n  font-weight: 400;\n  font-family: 'Graphik LCG';\n  src: url('./styles/fonts/GraphikLCG-Regular.ttf') format('truetype');\n  font-display: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
